import { injectable } from '~/container'
import { PayPalCallbackParams, PayPalCallbackServiceOutput } from './schema'

@injectable()
export abstract class PayPalCallbackService {
  get(
    _params: PayPalCallbackParams,
    _langCode: string,
  ): Promise<PayPalCallbackServiceOutput> {
    throw new Error('Not Implemented')
  }
}
